import React, { useEffect, useState } from 'react';

const CriteriaTemplate = ({ factorData, setAnswerFactor, currentAnswer, setSubPageInComplete }) => {
    const { factor, description, weight, grading, text_evaluations } = factorData;
    const key = currentAnswer.key;

    const [rating, setRating] = useState(null);
    const [textInputs, setTextInputs] = useState(
        Object.fromEntries(text_evaluations.map(te => [te.label.toLowerCase().replace(/\s/g, '_'), '']))
    );

    useEffect(() => {
        if (currentAnswer) {
            setRating(currentAnswer.data.grade);
            const updatedInputs = { ...textInputs };
            Object.keys(updatedInputs).forEach(k => {
                updatedInputs[k] = currentAnswer.data[k] ?? '';
            });
            setTextInputs(updatedInputs);
        }
    }, [currentAnswer]);

    // Validate input fields and trigger error state
    useEffect(() => {
        const isGradeInvalid = rating === null || rating === '';
        const isAnyTextInvalid = Object.values(textInputs).some(v => v === null || v.trim() === '');
        setSubPageInComplete(false);
        // setSubPageInComplete(false);
        // if (isGradeInvalid || isAnyTextInvalid) {
        //     setSubPageInComplete(true);
        // } else {
        //     setSubPageInComplete(false);
        // }
    }, [rating, textInputs]);

    const updateAnswer = (newRating, newInputs) => {
        const updatedEntry = {
            key,
            data: {
                grade: newRating,
                ...newInputs
            }
        };

        setAnswerFactor(prev => ({
            ...prev,
            factors: prev.factors.map(entry =>
                entry.key === key ? updatedEntry : entry
            )
        }));
    };

    const handleRatingChange = (value) => {
        setRating(value);
        updateAnswer(value, textInputs);
    };

    const handleTextChange = (label, value) => {
        const keyLabel = label.toLowerCase().replace(/\s/g, '_');
        const updatedInputs = {
            ...textInputs,
            [keyLabel]: value
        };
        setTextInputs(updatedInputs);
        updateAnswer(rating, updatedInputs);
    };

    return (
        <div className="evaluation-criteria mb-5">
            <div className="rating-header d-flex align-items-center justify-content-between">
                <span className="category-label label-semibold">{factor}</span>
                <div className="rating-scale d-flex align-items-center my-2">
                    <span className="progress-badge me-2">{weight}%</span>
                    {grading.map(({ value }) => (
                        <button
                            key={value}
                            className={`rating-btn label-semibold ${value === rating ? 'selected' : ''}`}
                            onClick={() => handleRatingChange(value)}
                        >
                            {value}
                        </button>
                    ))}
                </div>
            </div>

            <div className="rating-description text-end mb-1">
                {grading.map(({ value, note }) => (
                    <span key={value} className={`rating-label mx-2 ${value === rating ? 'selected' : ''}`}>
                        <span className='label-bold'>{value}</span> – {note}
                    </span>
                ))}
            </div>
            <div className="textarea-wrapper text-13">
                <label className='label-semibold text-13'>Description</label>
                <textarea
                    className="form-control desc text-13"
                    value={description}
                    readOnly
                />
            </div>
            {text_evaluations.map(({ label, max_chars }) => {
                const keyLabel = label.toLowerCase().replace(/\s/g, '_');
                return (
                    <div className="textarea-wrapper mb-2 text-13" key={label}>
                        <label className='label-semibold mb-1 text-13'>{label}</label>
                        <textarea
                            className="form-control text-13"
                            maxLength={max_chars}
                            value={textInputs[keyLabel]}
                            onChange={(e) => handleTextChange(label, e.target.value)}
                            disabled={rating === null}
                            title={rating === null ? 'Please select a grading first' : ''}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default CriteriaTemplate;
